<template lang="pug">
#footer
  contact
  footer.footer
    a(class="footer_link" href="https://www.ctc-g.co.jp/" target="_blank") CTCコーポレートサイトへ
    span (C) ITOCHU Techno-Solutions Corporation.
</template>

<script>
import contact from './templates/contact'

export default {
  name: 'contentFooter',
  components: {
    contact
  }
}
</script>

<style scoped lang="scss">
@import '../assets/stylesheets/variables';
@import '../assets/stylesheets/mixins';

.footer {
  @include bpOnlyPc() {
    flex-direction: row;
    justify-content: center;
  }
  @include bpOnlySp() {
    flex-direction: column;
    align-items: center;
  }
  display: flex;
  background: $buildNavy;
  color: $white;
  padding-bottom: 90px;
  font-size: 14px;
  font-weight: bold;
  &_link {
    @include bpOnlyPc() {
      margin-right: 60px;
    }
    @include bpOnlySp() {
      margin-bottom: 30px;
    }
    text-decoration: underline;
  }
}
</style>
